@if (initialized()) {
<ng-container ngProjectAs="container-start">
     <ng-content select="[slot=container-start]" />
</ng-container>
<swiper-container init="false"
                  #swiperContainerRef>
     @for (slide of slides(); track slide.slideIndex) {
     <swiper-slide class="swiper-slide">
          <ng-template [ngTemplateOutlet]="slide.template"
                       [ngTemplateOutletContext]="{
                               $implicit: slide.slideData
                             }" />
     </swiper-slide>
     }
</swiper-container>
<ng-container ngProjectAs="container-start">
     <ng-content select="[slot=container-end]" />
</ng-container>
} @else {
@if (placeholderTpl()) {
<ng-container *ngTemplateOutlet="placeholderTpl()!" />
} @else {
<div class="_placeholder">
     @for (slide of slides(); track slide.slideIndex) {
     <div class="_placeholder-slide">
          @if (placeholderSlideTpl()) {
          <ng-container *ngTemplateOutlet="placeholderSlideTpl()!" />
          } @else {
          <ng-template [ngTemplateOutlet]="slide.template"
                       [ngTemplateOutletContext]="{
                         $implicit: slide.slideData
                     }" />
          }
     </div>
     }
</div>
}
}